<template>
  <DialogTemplate
    id="shortcutdialog"
    data-tst="solfigr_shortcutdialog"
  >
    <SolfigrGmfForm
      :gameformat="gameformat"
      :namespace="tmpNamespace"
      :shortcut="l_shortcut"
      :startSpot="'flop'"
      @click:apply="apply"
      @update:shortcut="handleUpdateShortcut"
    >
    </SolfigrGmfForm>

    <template #dialog_actions>
      <v-btn
        class="mr-2 ml-auto"
        data-tst="btn_close"
        variant="text"
        @click="close"
        >{{ $t('btn.close') }}</v-btn
      >
      <portal-target name="dialog_actions" />
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import SolfigrGmfForm from '@/components/ConfigureSolution/SolfigrGmfForm'

export default {
  name: 'SolfigrShortcutDialog',
  components: {
    SolfigrGmfForm,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {
      l_shortcut: null,
    }
  },
  created() {
    this.$store.dispatch('poker_copy_module', {
      from_namespace: this.namespace,
      to_namespace: this.tmpNamespace,
      queryGroup: 'gmf-selektor',
    })

    this.$store.dispatch(`${this.tmpNamespace}/router_update_query`, {
      query: {
        solution_type: 'gwiz',
        fh_start_spot: 'custom_spot', // keep gmf selektor in single gametype mode
      },
      push: false,
      replace: false,
      saveLocally: false,
    })
  },
  methods: {
    handleUpdateShortcut(val) {
      this.l_shortcut = val
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-shortcuts-dialog')
    },
    apply() {
      this.$store.commit(`${this.namespace}/slfrm_set`, {
        key: 'slfrm_shortcut',
        value: this.l_shortcut,
      })
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.tmpNamespace,
        to_namespace: this.namespace,
        queryGroup: 'router-to-gmf-selektor',
      })
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: this.namespace,
        queryGroup: 'gmf-selektor-to-router',
      })

      if (this.l_shortcut?.apiShortcut) {
        // prefill from shortcut
        this.$store.dispatch('api_poker_shortcuts', {
          namespace: this.namespace,
          hasDepthList: false,
          action: `${this.namespace}/slfrm_applyApiShortcuts`,
        })
      } else {
        // prefill from preflop-actions
        this.$store.dispatch(
          'api_poker_player_ranges_spot',
          {
            // would be probably better if this was emited by the component
            // hSpots are not copied to tmp/primary
            namespace: this.namespace,
            tmpNamespace: this.tmpNamespace,
          },
          { root: true },
        )
      }

      this.$store.dispatch(`${this.namespace}/router_update_query`, {
        query: {},
        push: false,
        replace: true,
        saveLocally: true,
      })

      this.close()
    },
  },
  computed: {
    tmpNamespace() {
      return this.dialog.tmpNamespace || null
    },
    gameformat() {
      return this.$store.getters[`${this.tmpNamespace ? `${this.tmpNamespace}/` : ''}gameformat`]
    },

    namespace() {
      return this.dialog.namespace || null
    },
    labelId() {
      return this.dialog.labelId
    },
    shortcut() {
      return this.$store.getters[`${this.namespace}/slfrm_shortcut`]
    },
  },
}
</script>
